import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\GetScreenConfigListController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigListController.php
* @route '/api/screen-config'
*/
const GetScreenConfigListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenConfigListController.url(options),
    method: 'get',
})

GetScreenConfigListController.definition = {
    methods: ["get","head"],
    url: '/api/screen-config',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Screen\GetScreenConfigListController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigListController.php
* @route '/api/screen-config'
*/
GetScreenConfigListController.url = (options?: RouteQueryOptions) => {
    return GetScreenConfigListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\GetScreenConfigListController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigListController.php
* @route '/api/screen-config'
*/
GetScreenConfigListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenConfigListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Screen\GetScreenConfigListController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigListController.php
* @route '/api/screen-config'
*/
GetScreenConfigListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetScreenConfigListController.url(options),
    method: 'head',
})

export default GetScreenConfigListController